/* eslint-disable tss-unused-classes/unused-classes */
import { makeStyles } from 'tss-react/mui'

export const useNodesStyles = makeStyles()(theme => ({
  mainContainer: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
  },
  editorShell: {
    width: '100%',
    borderRadius: theme.shape.borderRadius,
    maxWidth: '1100px',
    color: theme.shape.markdownEditor.editorShellColor,
    position: 'relative',
    lineHeight: 1.7,
    fontWeight: theme.shape.markdownEditor.defaultFontWeight,
    border: `1px solid ${theme.palette.buttonGroup.borderColor}`,

    '.MarkdownEditor': {
      '&__h1': {
        fontSize: theme.typography.h1.fontSize,
        color: theme.typography.h1.color,
        fontWeight: theme.typography.h1.fontWeight,
        margin: '0',
      },
      '&__h2': {
        fontSize: theme.typography.h2.fontSize,
        color: theme.typography.h2.color,
        fontWeight: theme.typography.h2.fontWeight,
        margin: '0',
      },
      '&__h3': {
        fontSize: theme.typography.h3.fontSize,
        color: theme.typography.h3.color,
        fontWeight: theme.typography.h3.fontWeight,
        margin: '0',
      },
      '&__image': {},
      '&__link': {
        fontSize: theme.shape.markdownEditor.defaultFontSize,
        color: theme.palette.filter.activeText,
      },
      '&__checklist': {},
      '&__listItem': {
        '&Checked': {
          position: 'relative',
          paddingLeft: theme.spacing(4),
          marginRight: theme.spacing(1),
          listStyleType: 'none',
          outline: 'none',

          '&:before': {
            content: "''",
            width: '16px',
            height: '16px',
            top: '2px',
            left: '0',
            cursor: 'pointer',
            display: 'block',
            backgroundSize: 'cover',
            position: 'absolute',
            border: `1px solid ${theme.palette.filter.activeText}`,
            borderRadius: '2px',
            backgroundColor: theme.palette.filter.activeText,
            backgroundRepeat: 'no-repeat',
          },

          '&:focus': {
            '&:before': {
              boxShadow: '0 0 0 2px #a6cdfe',
              borderRadius: '2px',
            },
          },

          '&:after': {
            content: "''",
            cursor: 'pointer',
            borderColor: '#fff',
            borderStyle: 'solid',
            position: 'absolute',
            display: 'block',
            top: '6px',
            width: '3px',
            left: '7px',
            right: '7px',
            height: '6px',
            transform: 'rotate(45deg)',
            borderWidth: '0 2px 2px 0',
          },
          ':has(ul)': {
            paddingLeft: 0,
          },
        },
        '&Unchecked': {
          position: 'relative',
          paddingLeft: theme.spacing(4),
          marginRight: theme.spacing(1),
          listStyleType: 'none',
          outline: 'none',

          '&:before': {
            content: "''",
            width: '16px',
            height: '16px',
            top: '2px',
            left: '0',
            cursor: 'pointer',
            display: 'block',
            backgroundSize: 'cover',
            position: 'absolute',
            border: '1px solid #999',
            borderRadius: '2px',
          },

          '&:focus': {
            '&:before': {
              boxShadow: '0 0 0 2px #a6cdfe',
              borderRadius: '2px',
            },
          },
          ':has(ul)': {
            paddingLeft: 0,
          },
        },
      },
      '&__nestedListItem': {
        margin: `0 ${theme.spacing(2)}`,
        listStyleType: 'none',
        '&:before': {
          display: 'none',
        },
        '&:after': {
          display: 'none',
        },
      },
      '&__ol1': {
        padding: '0',
        margin: '0',
        listStylePosition: 'inside',
      },
      '&__ol2': {
        padding: '0',
        margin: '0',
        listStyleType: 'upper-alpha',
        listStylePosition: 'inside',
      },
      '&__ol3': {
        padding: '0',
        margin: '0',
        listStyleType: 'lower-alpha',
        listStylePosition: 'inside',
      },
      '&__ol4': {
        padding: '0',
        margin: '0',
        listStyleType: 'upper-roman',
        listStylePosition: 'inside',
      },
      '&__ol5': {
        padding: '0',
        margin: '0',
        listStyleType: 'lower-roman',
        listStylePosition: 'inside',
      },
      '&__ul': {
        padding: '0',
        margin: '0',
        listStylePosition: 'inside',
      },
      '&__paragraph': {
        margin: '0',
        position: 'relative',
      },
      '&__quote': {
        margin: '0',
        marginBottom: `${theme.spacing(1)}`,
        marginLeft: theme.spacing(2),
        fontSize: theme.typography.fontSize,
        color: theme.typography.h1.color,
        borderLeftColor: theme.palette.filter.activeText,
        borderLeftWidth: '4px',
        borderLeftStyle: 'solid',
        paddingLeft: theme.spacing(2),
      },
      '&__table': {
        borderCollapse: 'collapse',
        borderSpacing: '0',
        overflowY: 'scroll',
        overflowX: 'scroll',
        tableLayout: 'fixed',
        minWidth: '450px',
        width: 'max-content',
        margin: '0',
      },
      '&__tableCell': {
        border: `1px solid ${theme.palette.buttonGroup.borderColor}`,
        fontWeight: theme.shape.markdownEditor.defaultFontWeight,
        width: '75px',
        minWidth: '75px',
        verticalAlign: 'top',
        textAlign: 'center',
        padding: '6px 8px',
        position: 'relative',
        outline: 'none',
      },
      '&__tableRow': {
        ':first-of-type': {
          background: theme.shape.markdownEditor.tableHeaderBackground,
        },
      },
      '&__textBold': {
        fontWeight: 'bold',
      },
      '&__textItalic': {
        fontStyle: 'italic',
      },
      '&__textStrikethrough': {
        textDecoration: 'line-through',
      },
    },
  },
  editorShellError: {
    border: `1px solid ${theme.palette.error.main}`,
  },
  editorShellFocused: {
    border: `1px solid ${theme.shape.inputField.labelColorActive}`,
  },
  errorMessage: {
    margin: '4px 14px 0',
    color: theme.palette.error.main,
  },
  editorContainer: {
    background: theme.shape.markdownEditor.background,
    position: 'relative',
    display: 'block',
    borderBottomLeftRadius: '10px',
    borderBottomRightRadius: '10px',
  },
  editorScroller: {
    minHeight: '200px',
    border: '0',
    display: 'flex',
    position: 'relative',
    outline: '0',
    zIndex: 0,
    overflow: 'auto',
    resize: 'vertical',
  },
  editor: {
    flex: 'auto',
    position: 'relative',
    resize: 'vertical',
    zIndex: -1,
  },
}))
